<script>
// import slogan from '../assets/slogan.png';
import brand_img from '../assets/brand-img.png';
// import cf from '../assets/cf.png';
// import logoSrc from '../assets/logo.svg';
//ab1212
export default {
    data(){
        return {
            brand_img,
            video_text: "貴婦養成計畫第四集",
            link: "https://www.youtube.com/embed/XIyDmDMQQxs"
        }
    },
    methods: {

    },
    mounted(){

        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 1000);
        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 1500);
        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 2000);
        console.log("BDIntro!!")

    }
}

</script>

<template>
    <section class="brand-intro" id="brand-intro">

        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="video-box-wrap">
                        <div class="video-box">
                            <!-- <iframe id="video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe> -->
                            <iframe id="main-video" :src="`${link}?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1`" frameborder="0" allowfullscreen></iframe>
                            <!-- <img :src="cf" alt=""> -->
                        </div>
                        <p class="video-text">{{video_text}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="content-wrap">
                        <div class="img-wrap">
                            <img :src="brand_img" alt="">
                        </div>
                        <p class="text">
                            德國雙人誕生於 1731 年，是世界上現存最古老的商標之一，也是一種稀有品質與不朽傳奇的化身。起源于舉世聞名的德國刀劍製造中心索林根(Solingen)，280 多年來以獨特的刀具鋼材秘方及刀具工藝領先天下，是全球廚用刀具的頂級品牌。近代大力專注廚用鍋具發展，除了擁有特殊的鋼材配方，德國雙人在德國、日本、西班牙、比利時、法國、中國擁有自己的刀具鍋具工廠及研發基地，更在上海興業太古匯、巴黎香榭麗舍大街、西班牙巴賽隆納及德國杜塞爾多夫均設立了全球現代廚房時尚旗艦店。
                            <br><br>
德國雙人是不斷創新、有活力的品牌，宣導快樂、輕鬆、時尚廚藝生活。 雙人首創「摩登廚房」生活美學，力邀世界三大工業設計師之一的 Matteo Thun 為首席設計師，還曾與法國美食教父、連續 45 年獲得米其林三星稱號的保羅 • 博古斯親密合作， 打造現代摩登廚房，把廚房與餐廳變成社交空間，人們在這裡放鬆自己、呵護家人、關懷朋友，讓廚房與餐廳除了烹飪以外更充滿了生活色彩，致力於打造都市摩登廚房新風潮。 讓更多的美食烹飪愛好者回到廚房中去，享受烹飪帶來的美好體驗。
                        </p>
                    </div>

                    <!-- <div class="video-box-wrap">
                        <div class="video-box">
                            <div class="play-btn"></div>
                            <iframe id="brand-video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <p class="video-text">全聯福利中心BOGO FREE DANCE 買一送一</p>
                    </div> -->

                </div>
            </div>
        </div>
    </section>
</template>

<style lang="sass">



// @import "../sass/global.sass"
.brand-intro
    overflow: hidden
    position: relative
    background-image: url('../assets/grey-bg.jpg')
    background-size: cover
    padding-top: 80px
    padding-bottom: 80px
    @media (max-width: 991px)
        // margin-bottom: 70px
        padding-top: 80px
        padding-bottom: 80px
    @media (max-width: 768px)
        padding-top: 50px
        padding-bottom: 50px
    @media (max-width: 576px)
        padding-top: 40px
        padding-bottom: 40px




    .content-wrap
        //max-width: 50%
        background-color: #ab1212
        margin: 0 auto
        text-align: left
        padding-top: 50px
        padding-bottom: 70px
        border-radius: 30px
        padding-left: 30px
        padding-right: 30px
        @media (max-width: 991px)
            //max-width: 80%
            padding-top: 50px
            padding-bottom: 50px
        @media (max-width: 768px)
            max-width: 100%
        @media (max-width: 576px)
            padding: 30px 15px
        .img-wrap
            text-align: center
            margin-bottom: 45px
            @media (max-width: 991px)
                margin-bottom: 40px
            img
                width: 8%
                margin: 0 auto
                max-width: 150px
                min-width: 80px
                @media (max-width: 768px)
                    min-width: 100px
                @media (max-width: 576px)
                    min-width: 60px
                    max-width: 60px

        .text
            line-height: 30px
            color: white
            letter-spacing: 2px
            font-weight: 300
            font-size: 18px

    .video-box-wrap
        margin: 0 auto
        max-width: 50%
        margin-bottom: 50px
        @media (max-width: 991px)
            max-width: 70%
        @media (max-width: 768px)
            max-width: 100%
            //padding-bottom: 56.25%
        .video-box
            padding-bottom: 56.25%
            position: relative
            border-bottom: none

            border: 5px solid #000
            iframe, img
                background: black
                position: absolute
                display: block
                top: 50%
                left: 50%
                transform: translate(-50%, -50%)
                width: 100%
                height: 100%

        .video-text
            background: black
            padding: 15px 10px
            text-align: center
            color: white
            font-size: 18px
            letter-spacing: 1px
            @media (max-width: 576px)
                font-size: 14px



</style>



// WEBPACK FOOTER //
// src/Index/BrandIntro.vue